Monet.UI.Fields.GrowListCell = (function () {

    function GrowListCell () {

        var __index = null;
        var __growList = null;
        var __content = null;

        Monet.UI.Fields.Base.apply(this, arguments);
        this.createBaseStructure();

        this.setIndex = function (index) {

            __index = index;

        };

        this.getIndex = function () {

            return __index;

        };

        this.getGrowList = function () {

            return __growList;

        };

        this.setGrowList = function (growList) {

            __growList = growList;

        };

        this.getContent = function () {

            return __content;

        };

        this.setContent = function (content) {

            __content = content;

        };

        this.appendUtilityView = function (content) {

            this.rootEl.appendChild(content);

        };

        this.createElement = function () {

            var content = __content || document.createElement('div');

            this.rootEl = content;
            this.appendRemoveButton();

        };

        this.appendRemoveButton = function () {

            var removeButton = document.createElement('div');
            removeButton.className = 'buttonRemove';
            removeButton.innerHTML = '-';

            var removeAction = (function (scope) {

                return function () {

                    var growList = scope.getGrowList();
                    growList.removeCell(scope);

                };

            }(this));

            removeButton.removeEventListener('click', removeAction);
            removeButton.addEventListener('click', removeAction);
            this.appendUtilityView(removeButton);

        };

        this.render = function () {

            this.createElement();
            return this.rootEl;

        };

    }

    return GrowListCell;

}());
